var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSavingMoneyLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1649 18.3801C37.8249 18.4901 38.3049 19.06 38.3049 19.73V23.6901C38.3049 26.7901 38.1149 27.1901 35.6249 28.4701L32.8249 29.6501L30.4249 35.2801C30.1149 36.0201 29.3849 36.5001 28.5849 36.5001H26.1949C25.5349 36.5001 24.9949 35.96 24.9949 35.3V33.76C24.9949 33.1 24.4549 32.5601 23.7949 32.5601H20.7249C20.0649 32.5601 19.5249 33.1 19.5249 33.76V35.3C19.5249 35.96 18.9849 36.5001 18.3249 36.5001H15.8149C15.2449 36.5001 14.7049 36.26 14.3149 35.83C12.9249 34.28 9.75488 30.2101 9.75488 25.5601C9.75488 22.4801 10.4849 19.8 12.7449 17.52C15.0049 15.24 17.8349 14.4101 20.9049 14.4101H25.5549C25.5549 14.4101 25.7949 13.52 26.1749 12.86C26.9749 11.44 28.1049 10.9801 29.3449 10.8401C29.9449 10.7701 30.4749 11.2301 30.4749 11.8401V14.9301L34.0049 17.8401L37.1749 18.3801H37.1649Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.614 22.8501C30.4369 22.8501 31.104 22.183 31.104 21.3601C31.104 20.5372 30.4369 19.8701 29.614 19.8701C28.7911 19.8701 28.124 20.5372 28.124 21.3601C28.124 22.183 28.7911 22.8501 29.614 22.8501Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7842 19.3896H24.4842",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSavingMoneyLight);
export default __webpack_public_path__ + "static/media/icon_saving_money_light.da5d90f7.svg";
export { ForwardRef as ReactComponent };